import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import {
  Box,
  Dropdown,
  DropdownContent,
  DropdownGroup,
  DropdownTextInput,
  EmptyState,
  Scrollbar,
  SpinnerLoader,
  Typography,
  Error,
} from 'shared/ui'
import { Label } from 'shared/ui/Label'
import { makeTextFieldClear, makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { type TransferConversationModalStore } from 'widgets/TransferConversationModal/store/transferConversationModalStore'

import styles from '../styles.module.scss'

export interface IInboxesDropdownProps {
  store: TransferConversationModalStore
}
export const InboxesDropdown: FC<IInboxesDropdownProps> = observer(({ store }) => {
  const {
    searchInboxes,
    setSearchInboxes,
    inboxesDropdownItems,
    setActiveInboxId,
    activeInbox,
    activeOrganization,
    isEmptyInboxesDropdown,
    loadingInboxes,
    inboxError,
  } = store

  const TriggerComponent = () => {
    return (
      <>
        <TextFieldPlaceholder
          rightActions={[
            makeTextFieldIcon({
              icon: 'chevronDown',
              className: styles.iconAction,
            }),
          ]}
          placeholder={
            <Typography
              variant={'text-input-field-r'}
              color={
                activeInbox ? 'var(--content-primary-primary)' : 'var(--content-neutral-primary)'
              }
              ariaLabel={'organizationTriggerValue'}
            >
              {activeInbox ? activeInbox.name : 'Select'}
            </Typography>
          }
          leftActions={[
            makeTextFieldIcon({
              icon: 'inboxOpen',
              className: styles.iconAction,
            }),
          ]}
          className={classNames(styles.textField, {
            [styles.empty]: !activeInbox,
            [styles.disabled]: !activeOrganization,
            [styles.error]: !!inboxError,
          })}
          variant={'stroke'}
          size={'medium'}
        />
        <Error type={'text'} error={inboxError} />
      </>
    )
  }

  return (
    <div className={styles.wrapDropdown}>
      <Label
        label={{
          text: 'Select inbox',
        }}
        marginBottom={4}
      />
      <Dropdown
        width={432}
        ariaLabel={'inboxesDropdown'}
        triggerComponent={TriggerComponent}
        customComponent={(onClose) => {
          if (!activeOrganization) return null

          return (
            <DropdownContent noPadding>
              <DropdownTextInput
                textFieldProps={{
                  onChange: setSearchInboxes,
                  value: searchInboxes,
                  InputProps: {
                    placeholder: 'Search',
                  },
                  rightActions: [makeTextFieldClear()],
                }}
              />
              {loadingInboxes ? (
                <Box height={41}>
                  <SpinnerLoader ariaLabel={'InboxesDropdown'} size={16} />
                </Box>
              ) : (
                <Scrollbar autoHeight autoHeightMin={0} autoHeightMax={160}>
                  <div className={styles.listLabel}>
                    <Label
                      label={{
                        text: 'Inboxes',
                      }}
                    />
                  </div>
                  {isEmptyInboxesDropdown ? (
                    <EmptyState noIcon boxProps={{ height: 41 }} />
                  ) : (
                    <DropdownGroup
                      key={'inboxes'}
                      items={inboxesDropdownItems}
                      isScroll={false}
                      onChange={(value) => {
                        setActiveInboxId(value.id)
                        onClose()
                      }}
                    />
                  )}
                </Scrollbar>
              )}
            </DropdownContent>
          )
        }}
      />
    </div>
  )
})
